/**
 * @file 用户信息页面，目前只是token
 * @author fengfaxia(fengfaxia@baidu.com))
 * Copyright (c) 2018-10-16 Baidu
 */

import React from 'react';
import {Button, Modal, message} from 'antd';
import {Link} from 'react-router-dom';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {connect} from 'react-redux';

import './index.less';
import {
    setToken,
    setCurrentPage
} from '../../actions/generalAction';

class UserInfo extends React.Component {
    state = {
        visible: false
    }
    componentWillMount() {
        if (!this.props.token) {
            this.props.dispatch(setToken('GET'));
        }
    }
    confirmUpdateToken() {
        /* eslint-disable */
        _hmt.push(['_trackEvent', 'Token更换对话框', 'tokenchange_click_ok', '点击确认']);
        this.setState({
            visible: false
        });
        this.props.dispatch(setToken('PUT'));
    }
    hideModal() {
        _hmt.push(['_trackEvent', 'Token更换对话框', 'okenchange_click_cancel', '点击取消']);
        this.setState({
            visible: false
        });
    }
    showModal() {
        _hmt.push(['_trackEvent', 'Token配置页', 'tokenpage_click_change', '点击更换']);
        this.setState({
            visible: true
        });
    }
    copyUrl() {
        message.success('复制成功');
    }
    linkApiDoc() {
        _hmt.push(['_trackEvent', 'Token配置页', 'tokenpage_click_apilink', '点击API接口链接']);
        this.props.dispatch(setCurrentPage('apidoc'));
    }
    render() {
        return (
            <div className="container userinfo-container">
                <div className="row">
                    <h2 className="title">token信息</h2>
                    <p>
                        <span className="token">{this.props.token}</span>
                        <CopyToClipboard text={this.props.token} onCopy={this.copyUrl}>
                            <Button type="primary" className="copy-button" size="small" >复制</Button>
                        </CopyToClipboard>
                        <Button type="primary" onClick={() => this.showModal()} size="small" >更换</Button>
                        <Modal
                            title="系统提示"
                            visible={this.state.visible}
                            onOk={() => this.confirmUpdateToken()}
                            onCancel={() => this.hideModal()}
                            okText="确认"
                            cancelText="取消">
                            确定更换token信息吗?在更换token后，原来的token将失效<br/>
                            请在调用短网址API的程序中使用新的token
                        </Modal>
                    </p>
                </div>
                <div className="row">
                    <h2 className="title">token使用说明</h2>
                    <p>由数字和字母组成的32位字符，在调用
                        <Link to="/console/apidoc" onClick={() => this.linkApiDoc()}>API接口</Link>
                        时，用于鉴权</p>
                </div>
            </div>
        );
    }
}
export default connect(state => ({
    token: state.token,
    currentPage: state.currentPage
}))(UserInfo);
